<template>
  <body>
    <div class="sc-body">
      <div class="image-wrapper">
        <img
          class="image"
          src="../../../assets/sustainability/sus-commitment.png"
          alt="commitment"
        />
      </div>
      <div class="text-wrapper">
        <div class="title">
          At Wecobi, sustainability is more than just a commitment—it is the
          foundation upon which our entire platform is built.
        </div>
        <div class="text">
          We understand the profound environmental challenges posed by unsold
          inventory across various industries, from fashion and cosmetics to
          consumer electronics and home goods. The traditional disposal of these
          products—whether through incineration or landfill—results in
          significant environmental harm. Each year, millions of unsold items
          are discarded, contributing to escalating levels of waste, pollution,
          and resource depletion, estimated at $1.5 trillion annually. <br />
          <br />
          Wecobi is dedicated to changing this narrative.
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "SustainabilityCommitment",
};
</script>

<style scoped>
.sc-body {
  width: 100%;
  height: 820px;
  background: #f7f7fa;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
}
.image-wrapper {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.image {
  max-width: 480px;
  max-height: 611px;
}
.text-wrapper {
  height: 100%;
  max-width: 693px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.title {
  font-size: 35px;
  font-weight: 500;
  color: #000000;
  line-height: 1.4;
}
.text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

@media (max-width: 1280px) {
  .sc-body {
    justify-content: flex-start;
    height: 733px;
  }
  .image-wrapper {
    margin-left: 33px;
  }
  .image {
    max-width: 418px;
    max-height: 523px;
  }
  .text-wrapper {
    max-width: 547px;
  }
  .title {
    font-size: 27px;
  }
  .text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .sc-body {
    justify-content: flex-start;
    height: 614px;
    gap: 50px;
  }
  .image-wrapper {
    margin-left: 22px;
  }
  .image {
    max-width: 323px;
    max-height: 404px;
  }
  .text-wrapper {
    max-width: 459px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 744px) {
  .sc-body {
    justify-content: flex-start;
    height: 474px;
  }
  .image-wrapper {
    margin-left: 42px;
  }
  .image {
    max-width: 247px;
    max-height: 309px;
  }
  .text-wrapper {
    max-width: 322px;
  }
  .title {
    font-size: 18px;
  }
}
@media (max-width: 588px) {
  .sc-body {
    justify-content: flex-start;
    height: 567px;
    gap: 35px;
  }
  .image-wrapper {
    margin-left: -70px;
  }
  .image {
    max-width: 291px;
    max-height: 364px;
  }
  .text-wrapper {
    max-width: 247px;
  }
  .title {
    font-size: 18px;
  }
}
@media (max-width: 431px) {
  .sc-body {
    flex-direction: column;
    align-items: center;
    height: 924px;
    gap: 20px;
  }
  .image-wrapper {
    margin-left: 0px;
  }

  .text-wrapper {
    max-width: 358px;
  }
  .title {
    font-size: 25px;
  }
}
</style>
